import React, { useState, useEffect } from 'react';
import { useUser } from '../../context/userContext';
import { getConfig, setConfig } from '../../api/systemConfigApi';

const ToolDescription = ({ configKey }) => {
    const { user } = useUser();
    const isSuperAdmin = user?.roles?.includes('Super Admin');
    const [description, setDescription] = useState('');
    const [editText, setEditText] = useState('');
    const [editing, setEditing] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        getConfig(configKey)
            .then(res => setDescription(res.data.value || ''))
            .catch(() => {});
    }, [configKey]);

    const handleEdit = () => {
        setEditText(description);
        setEditing(true);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            await setConfig(configKey, editText);
            setDescription(editText);
            setEditing(false);
        } catch (err) {
            alert('Failed to save description: ' + (err.response?.data || err.message));
        } finally {
            setSaving(false);
        }
    };

    const handleCancel = () => {
        setEditing(false);
        setEditText('');
    };

    // Hide if no description and not super admin
    if (!description && !isSuperAdmin) return null;

    return (
        <div style={{
            margin: '0.75rem 1rem',
            padding: '0.75rem 1rem',
            background: '#f0f4ff',
            border: '1px solid #c7d7fe',
            borderRadius: '8px',
            fontSize: '0.85rem',
            color: '#1e3a5f',
            lineHeight: 1.6,
        }}>
            {editing ? (
                <>
                    <textarea
                        value={editText}
                        onChange={e => setEditText(e.target.value)}
                        rows={4}
                        style={{
                            width: '100%',
                            padding: '0.5rem',
                            fontSize: '0.85rem',
                            fontFamily: 'inherit',
                            border: '1px solid #93b4f5',
                            borderRadius: '6px',
                            resize: 'vertical',
                            outline: 'none',
                            lineHeight: 1.6,
                            background: '#fff',
                            color: '#1e3a5f',
                            boxSizing: 'border-box',
                        }}
                        placeholder="Enter description... (supports multiple lines)"
                        autoFocus
                    />
                    <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
                        <button
                            onClick={handleCancel}
                            style={{
                                padding: '0.3rem 0.75rem',
                                fontSize: '0.78rem',
                                border: '1px solid #ccc',
                                borderRadius: '5px',
                                background: '#fff',
                                cursor: 'pointer',
                            }}
                        >Cancel</button>
                        <button
                            onClick={handleSave}
                            disabled={saving}
                            style={{
                                padding: '0.3rem 0.75rem',
                                fontSize: '0.78rem',
                                border: 'none',
                                borderRadius: '5px',
                                background: '#3b82f6',
                                color: '#fff',
                                cursor: saving ? 'not-allowed' : 'pointer',
                                opacity: saving ? 0.6 : 1,
                            }}
                        >{saving ? 'Saving...' : 'Save'}</button>
                    </div>
                </>
            ) : (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}>
                    <div style={{ flex: 1, whiteSpace: 'pre-wrap' }}>
                        {description || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>No description yet. Click edit to add one.</span>}
                    </div>
                    {isSuperAdmin && (
                        <button
                            onClick={handleEdit}
                            title="Edit description"
                            style={{
                                padding: '0.2rem 0.5rem',
                                fontSize: '0.75rem',
                                border: '1px solid #93b4f5',
                                borderRadius: '5px',
                                background: '#fff',
                                color: '#3b82f6',
                                cursor: 'pointer',
                                flexShrink: 0,
                            }}
                        >Edit</button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ToolDescription;
